import { useEffect, useState } from "react";

import { useRecord, useRecords } from "@latticexyz/stash/react";
import mudConfig from "contracts/mud.config";
import { stash } from "../../../mud/stash";
import { useSessionPlayer } from "../../../SessionPlayerContext";

import { useGuide } from "../../GuideContext";
import { getGuideText, textConst } from "../../../text";

export const StateHome = ({shouldRender}) => {
  const { address: userAddress } = useSessionPlayer();

  const player = (userAddress) ? useRecord({
      stash, 
      table: mudConfig.tables.Player, 
      key: { counterValue: userAddress } 
    }) : false;
  
  const username = player.name;
  
  const [hasTriggeredIntroText, setHasTriggeredIntroText] = useState((player) ? player.hasWritten : false );

  const playerFaction = (player) ? useRecord({
    stash, 
    table: mudConfig.tables.Fraction, 
    key: { counterValue: player.fraction } 
  })?.fractionName : false;

  const players = useRecords({ 
    stash, 
    table: mudConfig.tables.Player 
  });
  
  const playersSorted = players
    .filter( ( record ) => {
      return record.wonAt > 0;
    })
    .sort( (a, b) => {
      return parseInt(b.wonAt) - parseInt(a.wonAt);
    });    

  const secretHolder = ( playersSorted.length > 0 ) ? playersSorted[0] : false;

  const {guideState, setGuideState} = useGuide();
  useEffect(() => { 
    if( shouldRender ){   
      if( !hasTriggeredIntroText ){   
        setGuideState({
          ...guideState,
          statement: getGuideText( 
            playerFaction, 
            textConst.INTROAREA, 
            [
              {find: '<username>', replace: username},
              {find: '<latestsecretholder>', replace: secretHolder}
            ] )
        })
      } else {
        // setGuideState({
        //   ...guideState,
        //   statement: ''
        // })
      }
      setHasTriggeredIntroText( true )
    }
  },[ shouldRender ]);
  return <>
    <div 
      className="game-state game-state__home" 
      style={{
        display: (shouldRender) ? 'block' : 'none'
      }}
    >
      
    </div>
  </>
}